module.exports = __webpack_public_path__ + "static/media/Программа_УОМШ-21.d5fd7b14.pdf";